const PaginationArrowLeftIcon = (props) => (
    <svg width="6" height="10" viewBox="0 0 6 10" {...props} xmlns="http://www.w3.org/2000/svg">
        <path d="M2.21871 4.99999L5.51871 8.29999L4.57604 9.24266L0.333374 4.99999L4.57604 0.757324L5.51871 1.69999L2.21871 4.99999Z" />
    </svg>
);

export default PaginationArrowLeftIcon;